<template>
  <div class="activitys-dialog-warp">
    <div
      class="dialog-mask"
      ref="dialogMask"
      @touchmove.stop.prevent
      v-if="dialogInfoList.length > 0"
    >
      <template>
        <van-swipe
          :loop="false"
          class="coupon-swipe"
          :show-indicators="dialogInfoList.length > 1"
          indicator-color="white"
        >
          <van-swipe-item
            class="coupon-swiper-item"
            :key="index"
            v-for="(item, index) in dialogInfoList"
          >
            <div
              class="dialog"
              :style="dialogStyle"
              ref="dialog"
            >
              <div class="dialog-warp">
                <div
                  class="dialog-body"
                  @touchmove.stop.prevent
                >
                  <div
                    class="dialog-close"
                    ref="closeIcon"
                    @click="dialogCloseFn(index)"
                  ></div>
                  <span class="icon-tag"></span>
                  <div
                    class="dialog-quan"
                    v-if="dialogInfoList[index].dialogStatus==1"
                  >
                    <div
                      class="dialog-quan-list"
                      @touchmove.stop="touchHandler($event, index)"
                    >
                      <div
                        class="dialog-quan-item"
                        v-for="(quan, index) in dialogInfoList[index].coupons"
                        :key="index"
                      >
                        <div class="item-fl">
                          <span v-if="quan.couponUseType == 'ORDER'">平台券</span>
                          <span v-if="quan.couponUseType == 'SHOP'">店铺券</span>
                          <strong v-if="quan.couponType == 'DISCOUNT_COUPON'">{{(quan.couponValue/10)}}<small>折</small></strong>
                          <strong v-else><small>￥</small>{{Number(quan.couponValue).toFixed(0)}}</strong>
                        </div>
                        <div class="item-fr">
                          <!-- <span>1张</span> -->
                          <h5>{{quan.activityName}}</h5>
                          <p>{{quan.description}}</p>
                          <p>{{quan.startTime && quan.startTime.split(' ')[0].replace(/-/g,'.')}}—{{quan.startTime && quan.endTime.split(' ')[0].replace(/-/g,'.')}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="dialog-text dialog-gpt"
                    v-show="dialogInfoList[index].dialogStatus==2"
                  >
                    <h4>领取成功！</h4>
                    <p>优惠券已发放到您的账户<br>请到“我的优惠券”查看</p>
                  </div>
                  <div
                    class="dialog-text dialog-pt"
                    v-show="dialogInfoList[index].dialogStatus==3"
                  >
                    <p>确定放弃领取优惠券吗？</p>
                  </div>
                </div>
                <div class="dialog-middle-img"></div>
                <div class="dialog-btns">
                  <a
                    href="javascript:;"
                    class="btn btn-cancel"
                    v-show="dialogInfoList[index].dialogStatus==3"
                    @click="doGiveUp(index)"
                  >确定放弃</a>
                  <a
                    href="javascript:;"
                    class="btn"
                    v-show="dialogInfoList[index].dialogStatus==3"
                    @click="doGetQuan(index)"
                  >立即领取</a>
                  <a
                    href="javascript:;"
                    class="btn-big"
                    v-show="dialogInfoList[index].dialogStatus==1"
                    @click="doGetQuan(index)"
                  >立即领取</a>
                  <a
                    href="javascript:;"
                    class="btn-big"
                    v-show="dialogInfoList[index].dialogStatus==2"
                    @click="goLookQuan(index)"
                  >去查看</a>
                </div>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </template>
    </div>
  </div>
</template>

<script>
import Api from '../api'

export default {
  name: 'couponActivitysDialog',
  props: {
    source: {
      type: String,
      default: () => '',
    },
    sourceId: {
      type: String,
      default: () => '',
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      dialogStatus: 0, // 弹窗状态  0关闭状态 1立即领取  2领取成功  3是否放弃
      dialogInfo: {}, // 弹窗信息
      dialogInfoList: [], // 弹窗信息列表
      dialogStyle: {}, // 弹框样式
    }
  },
  computed: {
    dialogShow() {
      return this.dialogInfoList && this.dialogInfoList.length > 0
    },
  },
  created() {
    Api.couponActivitysInfo({
      source: this.source,
      sourceId: this.sourceId,
    }).then(res => {
      let result = res.data
      if (result.success && result.data && result.data.length > 0) {
        result.data.forEach(ele => {
          if (ele.coupons && ele.coupons.length) {
            /*
             * targetType(用户身份):1、全部用户 2、新用户 3、老用户
             * (1，2，3)的用户身份在任何场景均需要弹框
             * 其他身份用户需要在(员工、服务兵)：ihaier\爱创客\顺逛\智家 内部弹框
             */
            if ([1, 2, 3].includes(+ele.targetType) || this.$util.isIhaierApp() || this.$util.isIMaker() || this.$util.isSgRn() || this.$util.isUplus() || this.show) {
              ele.dialogStatus = 1
              this.dialogInfoList.push(ele)
            }
          }
        })
      }
    })
  },
  watch: {
    dialogShow(val) {
      if (val === true) {
        this.$nextTick(() => {
          /*
           * 处理在大屏模式下顶部边距超出的问题
           * dialogMaskElementStyle：mask的底部距离
           * dialogElementStyle：dialog的底部距离
           * (childHeight.height + (childHeight.height * 30) / 234)：表示dialog底部内容的高度
           * 如果大屏模式下dialog超出mask的底部，则重新设置dialog的顶部padding：刚好露出底部
           */
          if (this.$refs.dialogMask && this.$refs.dialog && this.$refs.dialog[0]) {
            let dialogMaskElementStyle = this.$refs.dialogMask.getBoundingClientRect() || {}
            let dialogElementStyle = this.$refs.dialog[0].getBoundingClientRect() || {}
            let childHeight = (this.$refs.dialog[0].firstElementChild && this.$refs.dialog[0].firstElementChild.getBoundingClientRect()) || {}
            if (dialogMaskElementStyle.bottom && dialogElementStyle.bottom) {
              if (dialogMaskElementStyle.bottom < dialogElementStyle.bottom) {
                this.dialogStyle = {
                  paddingTop: dialogMaskElementStyle.bottom - (childHeight.height + (childHeight.height * 30) / 234) + 'px',
                }
              }
            }
          }
        })
      }
    },
  },
  methods: {
    touchHandler(e, index) {
      if (this.dialogInfoList[index].coupons.length <= 2) {
        e.preventDefault()
        e.returnValue = false
        return false
      } else {
        e.returnValue = true
        return true
      }
    },
    // 券弹窗
    dialogCloseFn(index) {
      // 2021/08/13 DSG-27833需求，应华要求去掉关闭时确认放弃功能

      // if (this.dialogInfoList[index].dialogStatus === 3 || this.dialogInfoList[index].dialogStatus === 2) {
      this.handleCloseCouponPop({
        activityId: this.dialogInfoList[index].id,
        endTime: this.dialogInfoList[index].endTime
      })
      this.dialogInfoList.splice(index, 1)
      // } else {
      //   this.dialogInfoList[index].dialogStatus = 3
      // }
    },
    // 确认放弃领券
    doGiveUp(index) {
      this.handleCloseCouponPop({
        activityId: this.dialogInfoList[index].id,
        endTime: this.dialogInfoList[index].endTime
      })
      this.dialogInfoList.splice(index, 1)
    },
    /**
     * @description 关闭弹窗优惠券方法
     * @param activityId 所关闭弹窗的活动id
     * @param endTime 优惠券活动结束时间 时间戳
    */
    handleCloseCouponPop(param) {
      return new Promise((resolve, reject) => {
        Api.closeCouponPop({
          activityId: param.activityId,
          endTime: param.endTime
        }).then(res => {
          let result = res.data
          if (result.success) {
            resolve()
          }
        })
      })
    },
    doGetQuan(index) {
      Api.receiveActivitysCoupons({
        activityId: this.dialogInfoList[index].id,
      }).then(res => {
        let result = res.data
        console.log(result, 'doGetQuan result')
        if (result.success) {
          this.dialogInfoList[index].dialogStatus = 2
        }
      })
    },
    goLookQuan(index) {
      this.dialogInfoList.splice(index, 1)
      this.$router.push('/coupon')
    },
  },
}
</script>

<style lang="scss" scoped>
.activitys-dialog-warp {
  .dialog-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 200;
  }

  .dialog {
    position: relative;
    // top: 60%;
    // left: 50%;
    // transform: translateX(-50%) translateY(-50%);
    padding-top: 85%;
    padding-bottom: 10%;
    z-index: 210;
  }

  .dialog-warp {
    margin: 0 auto;
    position: relative;
    width: 5.5rem;
    height: 4.26rem;
    background: #a83b30;
    border-radius: 0.36rem;
  }
  // .coupon-swipe {
  //   width: 100%;
  //   height: 100%;
  // }

  .dialog-body {
    position: absolute;
    left: 0.15rem;
    bottom: 1.35rem;
    width: 5.2rem;
    max-height: 6.2rem;
    padding-bottom: 1.5rem;
    background: linear-gradient(180deg, #f7f7f7, #fff2da);
    border-radius: 0.36rem;
    &::before {
      content: '';
      position: absolute;
      left: 0.35rem;
      top: -0.35rem;
      display: block;
      width: 0.82rem;
      height: 0.76rem;
      background: url(#{$cdnImageUrl}/home/popup/jinbitop.png) no-repeat;
      background-size: cover;
    }
    &::after {
      content: '';
      position: absolute;
      right: 0.15rem;
      top: -0.33rem;
      display: block;
      width: 0.72rem;
      height: 0.66rem;
      background: url(#{$cdnImageUrl}/home/popup/rightquan.png) no-repeat;
      background-size: cover;
    }
    .icon-tag {
      position: absolute;
      left: -0.25rem;
      top: 1.18rem;
      display: block;
      width: 0.52rem;
      height: 0.46rem;
      background: url(#{$cdnImageUrl}/home/popup/leftquan.png) no-repeat;
      background-size: cover;
    }

    .dialog-close {
      position: absolute;
      right: 0;
      top: -1.5rem;
      width: 0.7rem;
      height: 0.7rem;
      background: url(#{$cdnImageUrl}/home/popup/close.png) no-repeat;
      background-size: contain;
    }
  }
  .dialog-middle-img {
    position: absolute;
    left: -0.54rem;
    bottom: 1.3rem;
    width: 6.28rem;
    height: 2rem;
    background: url(#{$cdnImageUrl}/home/popup/img.png?t=1) no-repeat;
    background-size: cover;
  }

  .dialog-btns {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: #e83349;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 1.35rem;
    border-bottom-right-radius: 0.36rem;
    border-bottom-left-radius: 0.36rem;
    .btn-big {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 3.72rem;
      height: 0.84rem;
      background: url(#{$cdnImageUrl}/home/popup/btnlingqu.png?t=1) no-repeat;
      background-size: cover;
      font-size: 0.32rem;
      font-weight: 600;
      color: #b84605;
    }
    .btn {
      margin: 0 0.11rem;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 2.24rem;
      height: 0.76rem;
      background: url(#{$cdnImageUrl}/home/popup/btnlingqu_small.png?t=1) no-repeat;
      background-size: cover;
      box-sizing: border-box;
      font-size: 0.32rem;
      font-weight: 600;
      color: #b84605;
    }
    .btn-cancel {
      width: 2.24rem;
      height: 0.76rem;
      background: none;
      border: 0.02rem solid #ffce66;
      color: #ffce66;
      border-radius: 0.46rem;
    }
  }

  .dialog-quan {
    &::before {
      content: '';
      display: block;
      margin: 0.36rem auto;
      width: 3.4rem;
      height: 0.34rem;
      background: url(#{$cdnImageUrl}/home/popup/title_dialog.png) no-repeat;
      background-size: cover;
    }
  }

  .dialog-quan-list {
    padding: 0 0.3rem 0.4rem;
    margin: 0 0.1rem;
    max-height: 3.46rem;
    overflow-y: auto;
  }

  .dialog-quan-item {
    &:last-child {
      margin-bottom: 0;
    }
    margin-bottom: 0.2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 4.42rem;
    height: 1.54rem;
    background: url(#{$cdnImageUrl}/home/popup/quanbg.png) no-repeat;
    background-size: cover;
    .item-fl {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 1.44rem;
      height: 1.54rem;
      span {
        position: absolute;
        left: 0;
        top: 0.12rem;
        padding: 0.04rem 0.1rem;
        font-size: 0.2rem;
        color: #fff;
        border-bottom-right-radius: 0.4rem;
        border-top-right-radius: 0.4rem;
        background: rgba(#fff, 0.3);
      }
      strong {
        font-size: 0.48rem;
        color: #fff72f;
        font-weight: 700;
        small {
          font-size: 0.24rem;
        }
      }
    }
    .item-fr {
      width: 2.88rem;
      height: 1.54rem;
      padding-left: 0.18rem;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      span {
        position: absolute;
        right: 0.08rem;
        top: 0.08rem;
        padding: 0.05rem 0.15rem;
        font-size: 0.22rem;
        color: #9e4300;
        background: #ffc939;
        border-radius: 0.2rem;
      }
      h5 {
        font-size: 0.24rem;
        line-height: 0.34rem;
        color: #fff;
        @include text-overflow(1);
      }
      p {
        font-size: 0.2rem;
        line-height: 0.28rem;
        color: #fff;
        opacity: 0.7;
        @include text-overflow(1);
      }
    }
  }

  .dialog-text {
    padding-top: 0.65rem;
    color: #b84605;
    text-align: center;
    h4 {
      margin-bottom: 0.36rem;
      font-size: 0.32rem;
      font-weight: 600;
    }
    p {
      font-size: 0.28rem;
      line-height: 0.4rem;
    }
  }
  .dialog-pt {
    padding-top: 1.7rem;
    padding-bottom: 1rem;
  }
  .dialog-text {
    padding-bottom: 1rem;
  }
}
</style>
